import { CoreIcon } from '../core-icon';
import downloadSVG from '../../assets/icons/download.svg';
import type { IconProps } from '../core-icon';

export const DownloadIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={downloadSVG} {...props} />;
};
